<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <b-modal v-model="isDeleteModal"
             :no-close-on-backdrop="true"
             centered title="Delete modal"
             @cancel="closeDeleteModal"
             @ok="removeItem">
      <form>
        <h3 class="text-black-50">Are you sure want to delete?</h3>
      </form>
    </b-modal>
    <ListingComponent ref="degreeList"
                      class="bg-white"
                      :addNewButton="addNewButton"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
export default {
  name: 'DegreeListPage',
  data () {
    return {
      id: null,
      isDeleteModal: false,
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Action',
          value: (item) => {
            return (
              <b-dropdown variant="link" class="listing-action">
                <b-dropdown-item href={'#/degree/edit/' + item.id}>Edit</b-dropdown-item>
                <b-dropdown-item onClick={() => this.showDeleteModal(item)}>Delete</b-dropdown-item>
              </b-dropdown>
            )
          }
        },
        {
          columnCode: 'name',
          columnName: 'Name',
          align: 'left',
          value: item => {
            return item.name
          }
        },
        {
          columnCode: 'coin',
          columnName: 'Min. Coins',
          align: 'left',
          value: item => {
            return item.coin || 0
          }
        },
        {
          columnCode: 'active',
          columnName: 'Active',
          align: 'left',
          value: item => {
            return item.active ? 'ACTIVE' : 'INACTIVE'
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('telegram-member-degree/list', payload)
    },
    addNewButton () {
      return (<router-link class="btn btn-success mr-3" to="/degree/add"><div class="icon-plus"></div></router-link>)
    },
    closeDeleteModal () {
      this.id = null
      this.$nextTick(() => {
        this.isDeleteModal = false
      })
    },
    showDeleteModal (item) {
      if (!item.id) {
        this.$toastr.error('Item not found')
      }
      this.id = item.id
      this.isDeleteModal = true
    },
    removeItem () {
      if (!this.id) {
        return
      }
      this.$loading.show(true)
      this.axios.delete('telegram-member-degree/item', {params: {id: this.id}})
        .then((result) => {
          this.$refs.degreeList.doRequest()
          this.$loading.hide()
          if (result && result.data && result.data.status === 200) {
            this.$toastr.success('successfully deleted')
          }
          this.isDeleteModal = false
        })
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/degree/DegreeListPage.vue